import jwtDecode from 'jwt-decode';

export const checkAuthorization = () => {
	try {
		const user = jwtDecode(localStorage.wiselyToken);

		// if we don't have an expiry, the user is not authorized
		if (!user.exp) {
			return false;
		}

		// multiply unix timestamp by 1000 to get milliseconds for Date constructor
		const expiry = new Date(user.exp * 1000);
		const now = new Date();

		// (for the record, now < Invalid Date returns false)
		return now < expiry;
	} catch (e) {
		// we get here if the jwt is null/undefined or invalid
		return false;
	}
};

export const currentUserId = () => {
	try {
		const token = window.localStorage.wiselyToken;
		const auth = jwtDecode(token);
		return auth.userId;
	} catch (e) {
		return undefined;
	}
};



// WEBPACK FOOTER //
// ./src/utils/checkAuthorization.js